import React from 'react';
import ContentLoader from 'react-content-loader';

const TextLoader = ({ width = '100%', lineCount = 3, lineHeight = 20, lineSpacing = 10 }) => {
  const lines = Array.from({ length: lineCount }, (_, index) => (
    <rect
      key={index}
      x="0"
      y={index * (lineHeight + lineSpacing) + 5}
      rx="3"
      ry="2"
      width={`${Math.random() * 60 + 40}%`} // Random width between 40% and 100%
      height={lineHeight}
    />
  ));

  return (
    <ContentLoader
      speed={2}
      width={width}
      height={lineCount * (lineHeight + lineSpacing)}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      {lines}
    </ContentLoader>
  );
};

export default TextLoader;
